import React from "react";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Button,
  TextField,
  IconButton,
  CircularProgress
} from "@material-ui/core";
import { Grid as MUIGrid } from "@mui/material";
import CloseIcon from "@material-ui/icons/Close";
import { Autocomplete } from "@material-ui/lab";

const RegraFormModal = ({
  open,
  onClose,
  editMode,
  loadingEdit,
  currentRegra,
  onRegraChange,
  formErrors,
  onFormErrorChange,
  unidadesOptions,
  formasCobrancaOptions,
  cirurgioesOptions,
  loadingUnidades,
  loadingFormasCobranca,
  loadingCirurgioes,
  bplidOptions,
  loadingBplids,
  onSave
}) => {
  const businessUnitOptions = [
    { value: 'CUSTOMIZED', label: 'PERSONALIZADO' },
    { value: 'STANDARDIZED', label: 'PADRONIZADO' },
    { value: 'DOR', label: 'DOR' }
  ];

  return (
  <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
    <DialogTitle style={{ color: "#3f51b5", textAlign: 'center' }}>
      <span style={{ display: 'inline-block', width: '100%'}}>
        {editMode ? 'Editar Regra de Faturamento' : 'Nova Regra de Faturamento'}
      </span>
      <IconButton
        edge="end"
        color="inherit"
        onClick={onClose}
        aria-label="close"
        style={{ position: 'absolute', right: 30, top: 20, padding: 0 }}
      >
        <CloseIcon />
      </IconButton>
    </DialogTitle>
    <DialogContent>
      {editMode && loadingEdit ? (
        <div style={{ display: 'flex', justifyContent: 'center', padding: '60px 20px' }}>
          <CircularProgress />
        </div>
      ) : (
      <MUIGrid container spacing={2}>
        <MUIGrid item xs={12} md={6}>
          <Autocomplete
            options={businessUnitOptions}
            getOptionLabel={(option) => option.label}
            value={businessUnitOptions.find(o => o.value === currentRegra.BusinessUnit) || null}
            onChange={(_, newValue) => {
              onRegraChange({ ...currentRegra, BusinessUnit: newValue ? newValue.value : '' });
            }}
            renderInput={(params) =>
              <TextField
                {...params}
                label="Unidade de Negócio"
                variant="outlined"
              />
            }
          />
        </MUIGrid>
        <MUIGrid item xs={12} md={6}>
          <Autocomplete
            options={unidadesOptions}
            loading={loadingUnidades}
            getOptionLabel={(option) => option.name || ''}
            value={unidadesOptions.find(u => u.id === currentRegra.Unidade) || null}
            onChange={(event, newValue) => {
              onRegraChange({ ...currentRegra, Unidade: newValue ? newValue.id : '' });
            }}
            renderInput={(params) =>
              <TextField {...params} label="Unidade" variant="outlined" />
            }
          />
        </MUIGrid>
        <MUIGrid item xs={12} md={6}>
          <Autocomplete
            options={formasCobrancaOptions}
            loading={loadingFormasCobranca}
            getOptionLabel={(option) => option.name || ''}
            value={formasCobrancaOptions.find(f => f.id === currentRegra.FormaCobranca) || null}
            onChange={(event, newValue) => {
              onRegraChange({ ...currentRegra, FormaCobranca: newValue ? newValue.id : '' });
              onFormErrorChange(prev => ({ ...prev, FormaCobranca: !newValue }));
            }}
            renderInput={(params) =>
              <TextField
                {...params}
                label="Forma Cobrança *"
                variant="outlined"
                error={formErrors.FormaCobranca}
                helperText={formErrors.FormaCobranca ? "Campo obrigatório" : ""}
              />
            }
          />
        </MUIGrid>
        <MUIGrid item xs={12} md={6}>
          <Autocomplete
            options={cirurgioesOptions}
            loading={loadingCirurgioes}
            getOptionLabel={(option) => option.name || ''}
            value={cirurgioesOptions.find(c => c.id === currentRegra.Cirurgiao) || null}
            onChange={(event, newValue) => {
              onRegraChange({ ...currentRegra, Cirurgiao: newValue ? newValue.id : '' });
            }}
            renderInput={(params) =>
              <TextField {...params} label="Cirurgião" variant="outlined" />
            }
          />
        </MUIGrid>
        <MUIGrid item xs={12} md={6}>
          <Autocomplete
            options={bplidOptions}
            loading={loadingBplids}
            getOptionLabel={(option) => option.name || ''}
            value={bplidOptions.find(opt => String(opt.id) === String(currentRegra.BPLID)) || null}
            onChange={(_, newValue) => {
              const value = newValue ? newValue.id : '';
              onRegraChange({ ...currentRegra, BPLID: value });
              onFormErrorChange(prev => ({ ...prev, BPLID: !value }));
            }}
            renderInput={(params) =>
              <TextField
                {...params}
                label="BPLID *"
                variant="outlined"
                error={formErrors.BPLID}
                helperText={formErrors.BPLID ? "Campo obrigatório" : ""}
              />
            }
          />
        </MUIGrid>
        <MUIGrid item xs={12} md={6}>
          <TextField
            variant="outlined"
            fullWidth
            type="date"
            label="Data Início *"
            value={currentRegra.StartDate}
            onChange={(e) => {
              const value = e.target.value;
              onRegraChange({ ...currentRegra, StartDate: value });
              onFormErrorChange(prev => ({ ...prev, StartDate: !value }));
            }}
            error={formErrors.StartDate}
            helperText={formErrors.StartDate ? "Campo obrigatório" : ""}
            InputLabelProps={{ shrink: true }}
          />
        </MUIGrid>
        <MUIGrid item xs={12} md={6}>
          <TextField
            variant="outlined"
            fullWidth
            type="date"
            label="Data Fim"
            value={currentRegra.EndDate}
            onChange={(e) => onRegraChange({ ...currentRegra, EndDate: e.target.value })}
            InputLabelProps={{ shrink: true }}
          />
        </MUIGrid>
      </MUIGrid>
      )}
    </DialogContent>
    <DialogActions>
      <Button onClick={onClose} color="default">
        Cancelar
      </Button>
      <Button
        onClick={onSave}
        variant="contained"
        color="primary"
        disabled={editMode && loadingEdit}
      >
        {editMode ? 'Atualizar' : 'Salvar'}
      </Button>
    </DialogActions>
  </Dialog>
)};

export default RegraFormModal;
